import { render } from "./OddBtn.vue?vue&type=template&id=4231f7a8&scoped=true"
import script from "./OddBtn.vue?vue&type=script&lang=js"
export * from "./OddBtn.vue?vue&type=script&lang=js"

import "./OddBtn.vue?vue&type=style&index=0&id=4231f7a8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Dj_Volodya\\PycharmProjects\\7scalesProjects\\GeoffBanks\\geoff-banks-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4231f7a8"]])

export default __exports__